export default {
    title: "Commander au nom de",
    model: {
        email: {
            label: "E-mail",
            placeholder: "Veuillez indiquer votre nom d'utilisateur ou votre adresse e-mail",
            notFound: "Utilisateurs introuvables",
            errors: {
                myself: "L'adresse e-mail doit être différente de votre"
            }
        }
    },
    cta: {
        impersonate: {
            cta: "Soumettre",
            processing: "Soumission"
        }
    },
    error: {
        userNotExists: "{email} n'existe pas",
        country: {
            default: "OI n'est actuellement pas disponible dans le pays de l'utilisateur",
            ALPHA3: ""
        }
    }
}